{
 "note": "made by tools/make-sprites.py (render_top) from assets/models; do not edit. Front up, 11 px per metre, as cars.json",
 "image": "/sprites/fleet.png",
 "ppm": 11,
 "sprites": {
  "surveillance_van": {
   "x": 0,
   "y": 0,
   "w": 26,
   "h": 44
  },
  "auto_rickshaw": {
   "x": 28,
   "y": 0,
   "w": 19,
   "h": 32
  },
  "auto_rickshaw_black": {
   "x": 49,
   "y": 0,
   "w": 19,
   "h": 32
  },
  "quaternius-public-transport/Bus": {
   "x": 70,
   "y": 0,
   "w": 51,
   "h": 112
  },
  "kenney-car-kit/sedan": {
   "x": 123,
   "y": 0,
   "w": 26,
   "h": 41
  },
  "kenney-car-kit/taxi": {
   "x": 151,
   "y": 0,
   "w": 26,
   "h": 44
  },
  "kenney-car-kit/hatchback-sports": {
   "x": 179,
   "y": 0,
   "w": 23,
   "h": 45
  },
  "kenney-car-kit/suv": {
   "x": 204,
   "y": 0,
   "w": 26,
   "h": 43
  },
  "kenney-car-kit/van": {
   "x": 232,
   "y": 0,
   "w": 26,
   "h": 44
  },
  "kenney-car-kit/delivery": {
   "x": 260,
   "y": 0,
   "w": 26,
   "h": 51
  },
  "kenney-car-kit/delivery-flat": {
   "x": 288,
   "y": 0,
   "w": 26,
   "h": 51
  },
  "kenney-car-kit/truck": {
   "x": 316,
   "y": 0,
   "w": 26,
   "h": 47
  },
  "kenney-car-kit/truck-flat": {
   "x": 344,
   "y": 0,
   "w": 26,
   "h": 44
  },
  "kenney-car-kit/garbage-truck": {
   "x": 372,
   "y": 0,
   "w": 27,
   "h": 54
  }
 }
}
